module.exports = __webpack_public_path__ + "img/item7.5a96b52c.png";